module.exports = __webpack_public_path__ + "static/google_store_badge-b328376005d15506d0b655d5b8fbb6bf.svg";